export const INSTAGRAM_URL = 'https://www.instagram.com/corp.arquitetos/'
export const FACEBOOK_URL = 'https://www.facebook.com/corp.arquitetos/'
export const LINKEDIN_URL = 'https://www.linkedin.com/company/corp-arquitetos/'

export const INSTAGRAM_OPERE_URL = 'https://www.instagram.com/opere.visual/'
